import {datadogRum} from '@datadog/browser-rum'

export function initDataDogBrandSite({env, version}) {
  console.log('initDataDogBrandSite with env', env)

  const ignoredRumErrors = [
    'Expected at most 2 arguments for sendNativeMessage(), got 3', // sendNativeMessage is used for extensions messaging native host applications
    'Failed to connect to MetaMask', // Not our product
    "* is not an object (evaluating '* *.*')", // Safari/WebKit generic error with masked details
    'Invalid call to runtime.sendMessage(). Tab not found.', //extension process tries to message a tab that has been destroyed
    'Script error.', // Errors are unactionable: https://stackoverflow.com/a/7778424,
    '* is not *', // Safari/WebKit generic error with masked details
  ]

  datadogRum.init({
    applicationId: '24cdadfe-8196-4643-baaf-656f363e202a',
    clientToken: 'pubd936a99c65cbcaecdf6a0b67c62bf141',
    site: 'us5.datadoghq.com',
    service: 'bybe-brand-site',
    version: version || 'unknown',
    env: env || 'unknown',
    // We want errors/views/actions from all sessions for debugging:
    sessionSampleRate: 100,
    // RUM with replay is a little more expensive, and we rarely ever look at it:
    sessionReplaySampleRate: env == 'production' ? 10 : 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      /^https:\/\/(?:[a-zA-Z0-9-]+\.)*byberebates\.com(?:[/:?#]|$)/,
      /^https:\/\/(?:[a-zA-Z0-9-]+\.)*staging-byberebates\.com(?:[/:?#]|$)/,
    ],
    traceSampleRate: env == 'production' ? 10 : 100,
    beforeSend: (event) => {
      const errorMessage = event.error?.message || ''
      if (
        event.error?.source?.includes('extension://') ||
        ignoredRumErrors.some((ignoredError) =>
          errorMessage.includes(ignoredError),
        )
      ) {
        return false
      }
      return true
    },
  })
}
